import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/@next+third-parties@15.3.4_next@15.1.0_react@19.0.0-rc.1/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/@next+third-parties@15.3.4_next@15.1.0_react@19.0.0-rc.1/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/@next+third-parties@15.3.4_next@15.1.0_react@19.0.0-rc.1/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.1.0_@babel+core@7.26.0_babel-plugin-react-compiler@19.0.0-beta-df7b47d-20241124_react_bqxy2cmf63rbxemlwarzks4sqa/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.1.0_@babel+core@7.26.0_babel-plugin-react-compiler@19.0.0-beta-df7b47d-20241124_react_bqxy2cmf63rbxemlwarzks4sqa/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fira_Code\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-fira-code\"}],\"variableName\":\"firaCode\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/buildhome/repo/node_modules/.pnpm/react-hot-toast@2.5.2_react-dom@19.0.0-rc.1_react@19.0.0-rc.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/common/CautionBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/common/LoadingScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Header/BottomNavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Terms/terms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/hooks/Updaters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/hooks/useReduxProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/opt/buildhome/repo/src/utils/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/utils/appkit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/utils/QueryProvider.tsx");
